import { AxiosResponse } from 'axios'
import { inject, InjectionKey, ref } from 'vue'
import { Room } from '../../../libs/models'
import { useApi } from './api'
import polling from '../libs/polling'
import { lang } from './localization'

export interface RoomsStore {
  readonly value: Room[] | null
  remove: (ids: number[]) => void
}

const localizeRooms = (rooms: Room[]): Room[] => {
  if (lang !== 'en') return rooms
  return rooms
    .filter(room => room.id < 100 || room.id >= 200)
    .map(room => room.id < 100 ? { ...room, title: `${room.title} 🇯🇵` } : room)
}

export const generateRoomsStore = (): RoomsStore => {
  const rooms = ref<Room[] | null>(null)
  const api = useApi()
  const fetch = (): Promise<Room[]> => {
    return api.get('/rooms').then(({ data }: AxiosResponse<Room[]>) => {
      const localizedRooms = localizeRooms(data)
      rooms.value = localizedRooms
      return localizedRooms
    })
  }
  const remove = (ids: number[]) => {
    rooms.value = rooms.value?.filter(room => !ids.includes(room.id)) ?? []
    return api.post('/rooms/history/delete', { room_ids: ids })
  }
  polling((next: Function) => {
    fetch().then(() => {
      next(60000)
    })
  })
  return {
    get value () {
      return rooms.value
    },
    remove
  }
}
export const roomsStoreKey: InjectionKey<RoomsStore> = Symbol()
export const useRoomsStore = (): RoomsStore => {
  const roomsStore = inject(roomsStoreKey)
  if (!roomsStore) throw Error('Could not inject roomsStore')
  return roomsStore
}
